import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
export default {
  name: 'qinduquList',
  data() {
    return {
      heightdata: false,
      List: [],
      defaultdataList: [],
      map_type2: '',
      formObj: {
        map_type2: '',
        place_name: ''
      },
      listStyle: {},
      upFlag: false,
      loading: true,
      typeList: [],
      typeprops: {
        value: 'title',
        label: 'title'
      }
    };
  },
  components: {},
  watch: {
    '$attrs.datalist': {
      handler(val) {
        this.List = [...val];
        this.defaultdataList = [...val];
        console.log(`defaultdataList`, this.defaultdataList);
        if (this.List.length > 0) this.loading = false;
      }
    },
    '$attrs.style': {
      handler(val) {
        this.listStyle = {
          ...val
        };
        delete this.listStyle.width;
      },
      deep: true
    },
    '$attrs.formoption': {
      handler(val) {
        this.typeList = val.map(item => {
          const childData = JSON.parse(item.itemformdata.json.replace(/(<\/?p.*?>)/gi, ''));
          if (childData.length > 0) childData.unshift({
            title: '全部'
          });
          return {
            title: item.itemformdata.title,
            children: childData
          };
        });
        this.typeList.unshift({
          title: '全部'
        });
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    defaultChange(val) {
      this.map_type2 = val;
      this.typeHandleChange([...val]);
    },
    typeHandleChange(val) {
      if (val[0] === '全部') {
        this.formObj.map_type2 = '';
      } else if (val[1] === '全部') {
        this.formObj.map_type2 = val[0];
      } else {
        this.formObj.map_type2 = val.join('/');
      }
    },
    gosearch() {
      let filters = {};
      Object.keys(this.formObj).forEach(item => {
        filters[item] = this.formObj[item] === '' ? [] : this.formObj[item].toString().split(',');
      });
      let cacheData = JSON.parse(JSON.stringify(this.defaultdataList));
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.List = data.map(item => {
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe35/g, '\uff08');
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe36/g, '\uff09');
        return item;
      });
      this.$emit('searchtype', this.formObj.map_type2);
    },
    // 静态数据筛选
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        let itemflag = filterKeys.every(key => {
          // 自定义判断
          if (key === 'place_name') {
            return !!~item.itemformdata[key].indexOf(filters[key]);
          }
          if (!filters[key].length) return true;
          return !!~item.itemformdata[key].indexOf(filters[key]);
        });
        return itemflag;
      });
    },
    listmarkerclick(item) {
      this.$emit('listclick', item);
    },
    listUp() {
      console.log(`listUp`);
      this.upFlag = !this.upFlag;
      this.$emit('listup', this.upFlag);
    },
    listDown() {
      this.upFlag = false;
    },
    getTypeList(data) {
      cons;
    }
  }
};